import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import Select from "react-select";
import {
  AJOUTER_PRESTATAIRE,
  LISTE_COMMUNE,
  LISTE_COMMUNE_PRESTATAIRE,
} from "../../Utils/constant";
import { store } from "../../services/service";
import { useStoreCommune } from "../../store/storeCommune";

export const AddPrestataireCommune = ({ designation }) => {
  const { id } = useParams();
  const communeData = [];
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [select, setSelect] = useState([]);
  const listeCommune = useStoreCommune();
  const submit = (data) => {
    setIsSubmit(true);
    store(AJOUTER_PRESTATAIRE, "application/json", {
      designation: designation,
      listesCommunes: select.map((item) => item.value),
    })
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          listeCommune.getCommunePrestataire(
            `${LISTE_COMMUNE_PRESTATAIRE}/${id}?page=0&param=&size=10`
          );
          document.getElementById("close_prestataire_commune").click();
          reset();
          toast.success("Commune ajoutée ");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  useEffect(() => {
    listeCommune.getData(`${LISTE_COMMUNE}/${id}`);
  }, []);

  listeCommune?.data?.donnee?.map((item) => {
    return communeData.push({ value: item?.id, label: item?.designation });
  });

  return (
    <>
      <form onSubmit={handleSubmit(submit)} className="px-2">
        <div className="my-4 space-y-4">
          <div className="my-2">
            <label htmlFor="" className="text-sm font-medium">
              Commune <span className="text-red-500">*</span>
            </label>
            <Select
              isMulti
              onChange={(e) => setSelect(e)}
              options={communeData}
            />
          </div>

          <button
            type="submit"
            disabled={isSubmit ? true : false}
            className={`${
              !isSubmit ? "text-black bg-main" : "text-slate-800 bg-slate-200 "
            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
          >
            {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
            {isSubmit ? (
              <span className="loading loading-dots loading-xs"></span>
            ) : null}
          </button>
        </div>
      </form>
    </>
  );
};
